import { render, staticRenderFns } from "./platformPvSummaryList.vue?vue&type=template&id=6fad2cba&scoped=true&lang=pug&"
import script from "./platformPvSummaryList.vue?vue&type=script&lang=ts&"
export * from "./platformPvSummaryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad2cba",
  null
  
)

export default component.exports